import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`If you no longer wish to maintain a package, or if you would like to encourage users to update to a new or different version, you can `}<a parentName="p" {...{
        "href": "/cli/deprecate"
      }}>{`deprecate`}</a>{` it. Deprecating a package or version will print a message to the terminal when a user installs it.`}</p>
    <p>{`A deprecation warning or message can say anything. You may wish to include a message encouraging users to update to a specific version, or an alternate, supported package.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` We strongly recommend deprecating packages or package versions instead of `}<a href="/unpublishing-packages-from-the-registry">{`unpublishing`}</a>{` them, because unpublishing removes a package from the registry entirely, meaning anyone who relied on it will no longer be able to use it, with no warning.`}</p>
    </Note>
    <h2>{`Deprecating an entire package`}</h2>
    <p>{`Deprecating an entire package will remove it from search results on the
npm website and a deprecation message will also be displayed on the
package page.`}</p>
    <Screenshot src="/packages-and-modules/updating-and-managing-your-published-packages/deprecate-package.png" alt="Screenshot of package deprecation" mdxType="Screenshot" />
    <p>{`Deprecating a package is an alternative to deleting a package if
your package does not meet the
`}<a parentName="p" {...{
        "href": "/policies/unpublish"
      }}>{`unpublishing requirements`}</a>{`.`}</p>
    <h3>{`Using the website`}</h3>
    <ol>
      <li parentName="ol">
        <>{shared["user-login"].text}</>
        <>{shared["user-login"].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Navigate to the package page for the package you want to deprecate, replacing `}<inlineCode parentName="p">{`<your-package-name>`}</inlineCode>{` with the name of your package:
`}<inlineCode parentName="p">{`https://www.npmjs.com/package/<your-package-name>`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`Settings`}</strong>{`.`}</p>
        <Screenshot src="/packages-and-modules/securing-your-code/2fa-package-admin.png" alt="Screenshot showing the settings tab on a package page" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Under "deprecate package", click `}<strong>{`Deprecate package`}</strong>{`.`}</p>
        <Screenshot src="/packages-and-modules/deleting-deprecating/deprecate-package-settings.png" alt="Screenshot showing the deprecate package button" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`If you are sure that you want to continue, enter your package name and click `}<strong>{`Deprecate package`}</strong>{`.`}</p>
        <Screenshot src="packages-and-modules/deleting-deprecating/deprecate-package-confirm.png" alt="Screenshot showing the deprecate package confirmation" mdxType="Screenshot" />
      </li>
    </ol>
    <h3>{`Using the command line`}</h3>
    <p>{`To deprecate an entire package, run the following command, replacing `}<inlineCode parentName="p">{`<package-name>`}</inlineCode>{` with the name of your package, and `}<inlineCode parentName="p">{`"<message>"`}</inlineCode>{` with your deprecation message:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm deprecate <package-name> "<message>"
`}</code></pre>
    <p>{`If you have enabled `}<a parentName="p" {...{
        "href": "about-two-factor-authentication"
      }}>{`two-factor authentication`}</a>{`, add a one-time password to the command, `}<inlineCode parentName="p">{`--otp=123456`}</inlineCode>{` (where `}<em parentName="p">{`123456`}</em>{` is the code from your authenticator app).`}</p>
    <h2>{`Deprecating a single version of a package`}</h2>
    <p>{`When you deprecate a version of a package, a red message will be displayed on that version's package page, similar to deprecating an entire package.`}</p>
    <Screenshot src="/packages-and-modules/updating-and-managing-your-published-packages/deprecate-version.png" alt="Screenshot of package deprecation for a particular version" mdxType="Screenshot" />
    <h3>{`Using the command line`}</h3>
    <p>{`To deprecate a package version, run the following command, replacing `}<inlineCode parentName="p">{`<package-name>`}</inlineCode>{` with the name of your package, `}<inlineCode parentName="p">{`<version>`}</inlineCode>{` with your version number, and `}<inlineCode parentName="p">{`"<message>"`}</inlineCode>{` with your deprecation message:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm deprecate <package-name>@<version> "<message>"
`}</code></pre>
    <p>{`The CLI will also accept version ranges for `}<inlineCode parentName="p">{`<version>`}</inlineCode>{`.`}</p>
    <p>{`If you have two-factor auth, add a one-time password to the command, `}<inlineCode parentName="p">{`--otp=123456`}</inlineCode>{` (where `}<em parentName="p">{`123456`}</em>{` is the code from your authenticator).`}</p>
    <h2>{`Undeprecating a package or version`}</h2>
    <p>{`To undeprecate a package, replace `}<inlineCode parentName="p">{`"<message>"`}</inlineCode>{` with `}<inlineCode parentName="p">{`""`}</inlineCode>{` (an empty string) in one of the above commands.`}</p>
    <p>{`For example, to undeprecate a package version, run the following command, replacing `}<inlineCode parentName="p">{`<package-name>`}</inlineCode>{` with the name of your package, and `}<inlineCode parentName="p">{`<version>`}</inlineCode>{` with your version number:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm deprecate <package-name>@<version> ""
`}</code></pre>
    <p>{`If you have two-factor auth, add a one-time password to the command, `}<inlineCode parentName="p">{`--otp=123456`}</inlineCode>{` (where `}<em parentName="p">{`123456`}</em>{` is the code from your authenticator).`}</p>
    <h2>{`Transferring a deprecated package to npm`}</h2>
    <p>{`If you are no longer maintaining a package, but other users depend on it, and you'd like to remove it from your user profile, you can transfer it to the `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/~npm"
      }}><inlineCode parentName="a">{`@npm`}</inlineCode></a>{` user account, which is owned by the npm registry.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` Once you transfer a package to the npm account, you will no longer be able to update it.`}</p>
    </Note>
    <p>{`To transfer a package to the npm user account, run the following two commands in order, replacing `}<inlineCode parentName="p">{`<user>`}</inlineCode>{` with your npm user name, and `}<inlineCode parentName="p">{`<package-name>`}</inlineCode>{` with the package you want to transfer:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm owner add npm <package-name>
npm owner rm <user> <package-name>
`}</code></pre>
    <p>{`If you have two-factor auth, add a one-time password to the command, `}<inlineCode parentName="p">{`--otp=123456`}</inlineCode>{` (where `}<em parentName="p">{`123456`}</em>{` is the code from your authenticator).`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      